<script lang="ts">
  import ConfirmDialog from '@components/confirmDialog.svelte';
  import { confirmStore } from '$lib/confirm/confirm.svelte';
</script>

<ConfirmDialog
  open={confirmStore.open}
  title={confirmStore.options.title}
  message={confirmStore.options.message}
  confirmLabel={confirmStore.options.confirmLabel}
  cancelLabel={confirmStore.options.cancelLabel}
  danger={confirmStore.options.danger}
  onconfirm={() => confirmStore.accept()}
  oncancel={() => confirmStore.cancel()}
/>
